import React, { FC } from 'react';
import { useField } from 'react-final-form';

import { InputSizes } from '@mts-ds/components/dist/types/components/input/enums/sizes.enum';
import { TextareaSizes } from '@mts-ds/components/dist/types/components/textarea/enums/sizes.enum';
import { DropdownSizes } from '@mts-ds/components/dist/types/components/dropdown/enums/sizes.enum';

import FormGroup from '../../../../../../components_/Form/FormGroup';
import FormRow from '../../../../../../components_/Form/FormRow';
import FormCol from '../../../../../../components_/Form/FormCol';
import FormDoubleField from '../../../../../../components_/Form/FormDoubleField';
import FormColorPicker from '../../../../../../components_/Form/FormColorPicker';
import FormTimePicker from '../../../../../../components_/Form/FormTimePicker';
import FormInput from '../../../../../../components_/Form/FormInput';
import FormTextarea from '../../../../../../components_/Form/FormTextarea';
import FormDropdown from '../../../../../../components_/Form/FormDropdown';

import { hoursStep, minutesStep } from '../../../../../../constants/timeSteps';
import {
  required,
  size,
  immobilizedTimeSeconds as validateImmobilizedTimeSeconds
} from '../../../../../../utils/validation';

import { IProps as IFormProps } from './Form';
import FormAntSelect from '../../../../../../components_/Form/FormAntSelect';

interface IProps {
  data: IFormProps['data'];
}

const FormInfo: FC<IProps> = ({ data }) => {
  const { dangers, protections, areas, areasAppliance } = data;
  const areasOptions = areas.map(({ id, name }) => ({
    value: id,
    label: name
  }));
  const protectionsOptions = protections.map(({ id, name }) => ({
    value: id,
    label: name
  }));

  const applianceOptions = areasAppliance.map(({ systemName, friendlyName }) => ({
    value: systemName,
    label: friendlyName
  }));

  const {
    input: { value: applianceValue }
  } = useField<string>('appliance');

  const workingApplianceSystemName = React.useMemo(() => {
    const item = areasAppliance.find((a) =>
      a.friendlyName ? a.friendlyName.toLowerCase().includes('рабоч') : false
    );
    return item?.systemName;
  }, [areasAppliance]);

  const isWorkingZone = Boolean(applianceValue) && applianceValue === workingApplianceSystemName;

  return (
    <FormGroup title="Информация о зоне" size="s">
      <FormRow>
        <FormCol>
          <FormColorPicker name="mapColor" label="Цвет зоны" />
        </FormCol>
      </FormRow>
      <FormRow>
        <FormCol>
          <FormInput
            name="name"
            label="Название"
            placeholder="Введите название зоны"
            size={'s' as InputSizes}
            description="Допустимое количество символов: 20"
            useFieldConfig={{ validate: (value) => required(value) || size(value, 20) }}
          />
        </FormCol>
      </FormRow>
      <FormRow>
        <FormCol>
          <FormAntSelect
            name="appliance"
            label="Тип"
            placeholder="Выберите тип"
            size={'middle'}
            options={applianceOptions}
            useFieldConfig={{ validate: (value) => required(value)}}
          />
        </FormCol>
      </FormRow>
      <FormRow>
        <FormCol>
          <FormTextarea
            name="descr"
            label="Краткое описание (необязательно)"
            placeholder="Введите краткое описание зоны"
            size={'s' as TextareaSizes}
          />
        </FormCol>
      </FormRow>
      {isWorkingZone && (
        <>
      <FormRow>
        <FormCol>
          <FormDropdown
            name="dangerClassId"
            label="Класс опасности"
            placeholder="Выберите класс опасности"
            size={'s' as DropdownSizes}
            options={dangers}
            useFieldConfig={{ validate: required }}
          />
        </FormCol>
      </FormRow>
      <FormRow>
        <FormCol>
          <FormDoubleField
            label="Время работы зоны (необязательно)"
            separator="-"
            left={<FormTimePicker name="workStart" />}
            right={<FormTimePicker name="workEnd" />}
          />
        </FormCol>
      </FormRow>
      <FormRow>
        <FormCol>
          <FormDoubleField
            label="Разрешённое время в зоне (необязательно)"
            separator=":"
            left={
              <FormDropdown
                name="allowedHours"
                placeholder="Часы"
                size={'s' as DropdownSizes}
                options={hoursStep}
              />
            }
            right={
              <FormDropdown
                name="allowedMinutes"
                placeholder="Минуты"
                size={'s' as DropdownSizes}
                options={minutesStep}
              />
            }
          />
        </FormCol>
      </FormRow>
      <FormRow>
        <FormCol>
          <FormInput
            name="immobilizedTimeSeconds"
            label="Время обездвиженности, сек"
            placeholder="Необязательно"
            size={'s' as InputSizes}
            type="number"
            description="Оставьте пустым, если у зоны нет отдельного таймера"
            isHideDescription={false}
            useFieldConfig={{ validate: validateImmobilizedTimeSeconds }}
          />
        </FormCol>
      </FormRow>
      <FormRow>
        <FormCol>
          <FormAntSelect
            name="protectionsList"
            label="Обязательные СИЗ (необязательно)"
            placeholder="Выберите СИЗ"
            size={'middle'}
            options={protectionsOptions}
            mode="multiple"
          />
          {/*<FormDropdown*/}
          {/*  name="protectionsList"*/}
          {/*  label="Обязательные СИЗ (необязательно)"*/}
          {/*  placeholder="Выберите СИЗ"*/}
          {/*  size={'s' as DropdownSizes}*/}
          {/*  options={protections}*/}
          {/*  multiple*/}
          {/*/>*/}
        </FormCol>
      </FormRow>
      <FormRow>
        <FormCol>
          <FormAntSelect
            name="denyFrom"
            label="Запрещен вход из зон (необязательно)"
            placeholder="Выберите зоны"
            size={'middle'}
            options={areasOptions}
            mode="multiple"
          />
          {/*<FormDropdown*/}
          {/*  name="denyFrom"*/}
          {/*  label="Запрещен вход из зон (необязательно)"*/}
          {/*  placeholder="Выберите зоны"*/}
          {/*  size={'s' as DropdownSizes}*/}
          {/*  options={areas}*/}
          {/*  multiple*/}
          {/*/>*/}
        </FormCol>
      </FormRow>
        </>
      )}
    </FormGroup>
  );
};

export default FormInfo;
